import React from "react";
import { SvgIcon } from "@material-ui/core";

const GoogleIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.9931 8.14994C14.9931 7.49443 14.942 7.01608 14.8316 6.52002H7.65039V9.47868H11.8656C11.7806 10.2139 11.3217 11.3212 10.3019 12.0653L10.2876 12.1644L12.5582 13.9978L12.7155 14.0142C14.1602 12.6234 14.9931 10.5771 14.9931 8.14994Z"
          fill="#4285F4"
        />
        <path
          d="M7.64922 15.9451C9.71433 15.9451 11.448 15.2364 12.7143 14.014L10.3007 12.0651C9.65486 12.5346 8.78799 12.8623 7.64922 12.8623C5.62659 12.8623 3.90991 11.4716 3.29796 9.54932L3.20826 9.55726L0.847282 11.4618L0.816406 11.5513C2.07417 14.1556 4.65772 15.9451 7.64922 15.9451Z"
          fill="#34A853"
        />
        <path
          d="M3.29737 9.54936C3.13591 9.0533 3.04246 8.52176 3.04246 7.97257C3.04246 7.42332 3.13591 6.89184 3.28888 6.39577L3.2846 6.29013L0.894048 4.35498L0.815834 4.39376C0.29745 5.47449 0 6.68811 0 7.97257C0 9.25703 0.29745 10.4706 0.815834 11.5513L3.29737 9.54936Z"
          fill="#FBBC05"
        />
        <path
          d="M7.6492 3.08269C9.08542 3.08269 10.0542 3.72934 10.6066 4.26974L12.7653 2.07286C11.4395 0.788397 9.7143 0 7.6492 0C4.65771 0 2.07417 1.78937 0.816406 4.39371L3.28945 6.39573C3.9099 4.47347 5.62657 3.08269 7.6492 3.08269Z"
          fill="#EB4335"
        />
      </svg>
    </SvgIcon>
  );
};

export const HomeIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.7083 4.15082L3.66696 9.57464V15.4285C3.66696 15.5801 3.73134 15.7254 3.84593 15.8326C3.96053 15.9398 4.11596 16 4.27802 16L8.55776 15.9896C8.71929 15.9889 8.87394 15.9283 8.98787 15.8212C9.10181 15.7142 9.16577 15.5692 9.16577 15.4181V11.9996C9.16577 11.848 9.23015 11.7026 9.34474 11.5954C9.45934 11.4883 9.61477 11.4281 9.77683 11.4281H12.2211C12.3832 11.4281 12.5386 11.4883 12.6532 11.5954C12.7678 11.7026 12.8322 11.848 12.8322 11.9996V15.4157C12.8319 15.4909 12.8475 15.5654 12.8781 15.6349C12.9087 15.7044 12.9537 15.7677 13.0105 15.8209C13.0672 15.8742 13.1347 15.9164 13.2089 15.9453C13.2832 15.9741 13.3628 15.9889 13.4432 15.9889L17.7214 16C17.8835 16 18.0389 15.9398 18.1535 15.8326C18.2681 15.7254 18.3325 15.5801 18.3325 15.4285V9.57071L11.2927 4.15082C11.2099 4.08843 11.1068 4.05441 11.0005 4.05441C10.8942 4.05441 10.7911 4.08843 10.7083 4.15082ZM21.8308 7.8373L18.638 5.37596V0.428619C18.638 0.314942 18.5897 0.205921 18.5038 0.12554C18.4178 0.0451581 18.3013 0 18.1797 0H16.041C15.9195 0 15.8029 0.0451581 15.7169 0.12554C15.631 0.205921 15.5827 0.314942 15.5827 0.428619V3.02212L12.1634 0.391115C11.8353 0.138579 11.4235 0.000504823 10.9986 0.000504823C10.5736 0.000504823 10.1619 0.138579 9.83374 0.391115L0.166323 7.8373C0.119916 7.87318 0.0815212 7.91725 0.0533329 7.96701C0.0251445 8.01676 0.00771497 8.07123 0.00204025 8.12728C-0.00363448 8.18334 0.00255679 8.23989 0.0202603 8.29371C0.0379638 8.34753 0.0668326 8.39756 0.105217 8.44094L1.0791 9.54821C1.11738 9.59174 1.16446 9.62778 1.21766 9.65428C1.27085 9.68077 1.32911 9.69719 1.3891 9.7026C1.44908 9.70801 1.50962 9.70229 1.56725 9.68579C1.62487 9.66929 1.67845 9.64232 1.72492 9.60643L10.7083 2.68637C10.7911 2.62398 10.8942 2.58996 11.0005 2.58996C11.1068 2.58996 11.2099 2.62398 11.2927 2.68637L20.2764 9.60643C20.3228 9.64233 20.3763 9.66933 20.4339 9.68589C20.4914 9.70244 20.5519 9.70823 20.6118 9.70293C20.6718 9.69762 20.73 9.68132 20.7832 9.65495C20.8364 9.62859 20.8835 9.59268 20.9219 9.54928L21.8958 8.44201C21.9341 8.39838 21.9628 8.34809 21.9803 8.29404C21.9978 8.23999 22.0037 8.18323 21.9977 8.12704C21.9917 8.07084 21.9738 8.01632 21.9452 7.96659C21.9165 7.91687 21.8777 7.87293 21.8308 7.8373Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

 

export const SavedIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="14"
        height="20"
        viewBox="0 0 14 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 20V1.875C0 0.839453 0.78349 0 1.75 0H12.25C13.2165 0 14 0.839453 14 1.875V20L7 15.625L0 20Z"
          fill="#F5F5F5"
        />
      </svg>
    </SvgIcon>
  );
};

export const WalletIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.20697 3.27746L11.3826 1.32572L11.0026 0.560335C10.754 0.0628339 10.1476 -0.142612 9.64835 0.105132L3.22461 3.27746H4.20697Z"
          fill="#F5F5F5"
        />
        <path
          d="M13.6097 1.38281C13.5208 1.38281 13.4318 1.3949 13.3429 1.41907L11.6571 1.8783L6.50879 3.27815H12.3524H14.8993L14.584 2.12604C14.4627 1.67688 14.0544 1.38281 13.6097 1.38281Z"
          fill="#F5F5F5"
        />
        <path
          d="M15.9522 3.98291H15.7218H15.4085H15.0952H12.704H3.91731H2.76516H1.79493H1.61503H1.01268C0.693312 3.98291 0.408306 4.12994 0.222345 4.36158C0.13745 4.46833 0.0727674 4.59119 0.0363837 4.72614C0.0141492 4.81074 0 4.89936 0 4.99V5.11085V6.25893V16.211C0 16.7669 0.452775 17.2181 1.01066 17.2181H15.9502C16.5081 17.2181 16.9609 16.7669 16.9609 16.211V13.4012H10.9636C10.0156 13.4012 9.24551 12.6338 9.24551 11.6891V10.7667V10.4545V10.1423V9.44938C9.24551 8.98612 9.43145 8.56518 9.73264 8.25701C9.99946 7.98306 10.3572 7.79776 10.7575 7.75143C10.8242 7.74339 10.8929 7.73935 10.9616 7.73935H16.12H16.4333H16.7466H16.9609V4.99C16.9629 4.43409 16.5101 3.98291 15.9522 3.98291Z"
          fill="#F5F5F5"
        />
        <path
          d="M17.6705 8.70085C17.5695 8.6082 17.4502 8.5377 17.3168 8.49137C17.2137 8.45715 17.1045 8.43701 16.9893 8.43701H16.9631H16.9428H16.6295H15.4996H10.9638C10.4059 8.43701 9.95312 8.88817 9.95312 9.4441V9.94561V10.2578V10.57V11.6859C9.95312 12.2418 10.4059 12.6929 10.9638 12.6929H16.9631H16.9893C17.1045 12.6929 17.2137 12.6728 17.3168 12.6386C17.4502 12.5942 17.5695 12.5217 17.6705 12.4291C17.8726 12.2458 18 11.9799 18 11.6859V9.4441C18 9.15001 17.8726 8.88412 17.6705 8.70085ZM13.074 10.7654C13.074 11.0433 12.8477 11.2689 12.5687 11.2689H12.2332C11.9542 11.2689 11.7278 11.0433 11.7278 10.7654V10.431C11.7278 10.2699 11.8026 10.1269 11.9219 10.0362C12.0088 9.96976 12.116 9.92748 12.2332 9.92748H12.3181H12.5687C12.8477 9.92748 13.074 10.153 13.074 10.431V10.7654Z"
          fill="#F5F5F5"
        />
      </svg>
    </SvgIcon>
  );
};

export const LeagueIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.125 2.25H16.3333V0.84375C16.3333 0.376172 15.9432 0 15.4583 0H5.54167C5.05677 0 4.66667 0.376172 4.66667 0.84375V2.25H0.875C0.390104 2.25 0 2.62617 0 3.09375V5.0625C0 6.31758 0.820312 7.60781 2.25677 8.60273C3.40521 9.40078 4.80156 9.90703 6.26719 10.0687C7.41198 11.9004 8.75 12.6562 8.75 12.6562V15.1875H7C5.71302 15.1875 4.66667 15.9152 4.66667 17.1562V17.5781C4.66667 17.8102 4.86354 18 5.10417 18H15.8958C16.1365 18 16.3333 17.8102 16.3333 17.5781V17.1562C16.3333 15.9152 15.287 15.1875 14 15.1875H12.25V12.6562C12.25 12.6562 13.588 11.9004 14.7328 10.0687C16.2021 9.90703 17.5984 9.40078 18.7432 8.60273C20.176 7.60781 21 6.31758 21 5.0625V3.09375C21 2.62617 20.6099 2.25 20.125 2.25ZM3.62031 6.77813C2.73073 6.15938 2.33333 5.47031 2.33333 5.0625V4.5H4.67396C4.71042 5.64609 4.88542 6.65156 5.14062 7.53047C4.5901 7.34766 4.07604 7.09453 3.62031 6.77813ZM18.6667 5.0625C18.6667 5.62852 18.0214 6.33164 17.3797 6.77813C16.924 7.09453 16.4062 7.34766 15.8557 7.53047C16.1109 6.65156 16.2859 5.64609 16.3224 4.5H18.6667V5.0625Z"
          fill="#F5F5F5"
        />
      </svg>
    </SvgIcon>
  );
};

export const InviteIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7758 6.74981H11.5508V8.71873C11.5508 10.1145 10.4405 11.2502 9.07577 11.2502C7.71108 11.2502 6.60077 10.1145 6.60077 8.71873V4.44337L4.36984 5.81457C3.7064 6.2189 3.30078 6.95373 3.30078 7.7413V9.40433L0.550783 11.0287C0.0248465 11.3381 -0.157341 12.0272 0.148596 12.5651L2.89859 17.4382C3.20109 17.9761 3.87484 18.159 4.40078 17.8496L7.95514 15.7506H12.6508C13.8642 15.7506 14.8508 14.7415 14.8508 13.5004H15.4008C16.0092 13.5004 16.5008 12.9976 16.5008 12.3753V10.1251H16.7758C17.2329 10.1251 17.6008 9.74889 17.6008 9.28127V7.59363C17.6008 7.12601 17.2329 6.74981 16.7758 6.74981ZM21.8529 5.43485L19.1029 0.561787C18.8004 0.0238509 18.1267 -0.158977 17.6008 0.150424L14.0464 2.24943H10.5333C10.1208 2.24943 9.71858 2.36897 9.36795 2.59047L8.21639 3.3253C7.89327 3.52923 7.70077 3.89137 7.70077 4.27812V8.71873C7.70077 9.49574 8.31608 10.1251 9.07577 10.1251C9.83545 10.1251 10.4508 9.49574 10.4508 8.71873V5.62471H16.7758C17.8379 5.62471 18.7008 6.50721 18.7008 7.59363V8.59567L21.4507 6.97131C21.9767 6.6584 22.1554 5.97279 21.8529 5.43485Z"
          fill="#F5F5F5"
        />
      </svg>
    </SvgIcon>
  );
};

export const FolderIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.2 1.5C2.01435 1.5 1.8363 1.57375 1.70503 1.70503C1.57375 1.8363 1.5 2.01435 1.5 2.2V5.075H14.5V4.375C14.5 4.18935 14.4263 4.0113 14.295 3.88003C14.1637 3.74875 13.9857 3.675 13.8 3.675H7.275C7.02424 3.675 6.79006 3.54967 6.65096 3.34103L5.42361 1.5H2.2ZM14.5 6.575H1.5V12.35C1.5 12.5357 1.57375 12.7137 1.70503 12.845C1.8363 12.9763 2.01435 13.05 2.2 13.05H13.8C13.9857 13.05 14.1637 12.9763 14.295 12.845C14.4263 12.7137 14.5 12.5357 14.5 12.35V6.575ZM0.644365 0.644365C1.05695 0.231785 1.61652 0 2.2 0H5.825C6.07577 0 6.30994 0.125326 6.44904 0.333975L7.67639 2.175H13.8C14.3835 2.175 14.9431 2.40679 15.3556 2.81937C15.7682 3.23194 16 3.79152 16 4.375V12.35C16 12.9335 15.7682 13.4931 15.3556 13.9056C14.9431 14.3182 14.3835 14.55 13.8 14.55H2.2C1.61652 14.55 1.05694 14.3182 0.644365 13.9056C0.231785 13.4931 0 12.9335 0 12.35V2.2C0 1.61652 0.231785 1.05695 0.644365 0.644365Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export const SettingsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7829 11.1629L15.2577 10.2702C15.4116 9.42822 15.4116 8.56452 15.2577 7.72259L16.7829 6.82985C16.9583 6.72823 17.0371 6.51775 16.9798 6.32178C16.5824 5.02985 15.9057 3.86131 15.0214 2.88873C14.8853 2.73994 14.6633 2.70365 14.4915 2.80527L12.9663 3.698C12.3254 3.13914 11.5879 2.70728 10.7894 2.42422V0.64237C10.7894 0.439145 10.6498 0.261323 10.4529 0.217775C9.13893 -0.0798044 7.79274 -0.0652883 6.54321 0.217775C6.3463 0.261323 6.20667 0.439145 6.20667 0.64237V2.42785C5.41184 2.71454 4.6743 3.14639 4.02984 3.70163L2.50822 2.80889C2.33278 2.70728 2.11438 2.73994 1.97833 2.89236C1.094 3.86131 0.417324 5.02985 0.0199107 6.32541C-0.0409543 6.52138 0.0413925 6.73186 0.216827 6.83348L1.74203 7.72621C1.58808 8.56815 1.58808 9.43185 1.74203 10.2738L0.216827 11.1665C0.0413925 11.2681 -0.037374 11.4786 0.0199107 11.6746C0.417324 12.9665 1.094 14.1351 1.97833 15.1076C2.11438 15.2564 2.33636 15.2927 2.50822 15.1911L4.03342 14.2984C4.6743 14.8572 5.41184 15.2891 6.21025 15.5722V17.3576C6.21025 17.5609 6.34988 17.7387 6.54679 17.7822C7.86076 18.0798 9.20695 18.0653 10.4565 17.7822C10.6534 17.7387 10.793 17.5609 10.793 17.3576V15.5722C11.5879 15.2855 12.3254 14.8536 12.9698 14.2984L14.4951 15.1911C14.6705 15.2927 14.8889 15.2601 15.0249 15.1076C15.9093 14.1387 16.5859 12.9701 16.9834 11.6746C17.0371 11.475 16.9583 11.2645 16.7829 11.1629ZM8.49806 11.8996C6.91914 11.8996 5.63382 10.5968 5.63382 8.99637C5.63382 7.39597 6.91914 6.09316 8.49806 6.09316C10.077 6.09316 11.3623 7.39597 11.3623 8.99637C11.3623 10.5968 10.077 11.8996 8.49806 11.8996Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export const SearchIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.625 3.5C6.24226 3.5 3.5 6.24226 3.5 9.625C3.5 13.0077 6.24226 15.75 9.625 15.75C13.0077 15.75 15.75 13.0077 15.75 9.625C15.75 6.24226 13.0077 3.5 9.625 3.5ZM1.75 9.625C1.75 5.27576 5.27576 1.75 9.625 1.75C13.9742 1.75 17.5 5.27576 17.5 9.625C17.5 13.9742 13.9742 17.5 9.625 17.5C5.27576 17.5 1.75 13.9742 1.75 9.625Z"
          fill="#46445C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9496 13.9496C14.2913 13.6079 14.8454 13.6079 15.1871 13.9496L18.9933 17.7559C19.335 18.0976 19.335 18.6516 18.9933 18.9933C18.6516 19.335 18.0976 19.335 17.7559 18.9933L13.9496 15.1871C13.6079 14.8454 13.6079 14.2913 13.9496 13.9496Z"
          fill="#46445C"
        />
      </svg>
    </SvgIcon>
  );
};

export const RecruiterIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="20"
        viewBox="0 0 17 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 10C11.1828 10 13.3571 7.76172 13.3571 5C13.3571 2.23828 11.1828 0 8.5 0C5.81719 0 3.64286 2.23828 3.64286 5C3.64286 7.76172 5.81719 10 8.5 10ZM12.1353 11.2734L10.3214 18.75L9.10714 13.4375L10.3214 11.25H6.67857L7.89286 13.4375L6.67857 18.75L4.86473 11.2734C2.15915 11.4062 0 13.6836 0 16.5V18.125C0 19.1602 0.815848 20 1.82143 20H15.1786C16.1842 20 17 19.1602 17 18.125V16.5C17 13.6836 14.8408 11.4062 12.1353 11.2734Z"
          fill="#FEFEFE"
        />
      </svg>
    </SvgIcon>
  );
};
export const InsightsIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.375 12.5H2.5V0.625C2.5 0.279687 2.22031 0 1.875 0H0.625C0.279687 0 0 0.279687 0 0.625V13.75C0 14.4402 0.559766 15 1.25 15H19.375C19.7203 15 20 14.7203 20 14.375V13.125C20 12.7797 19.7203 12.5 19.375 12.5ZM18.125 1.25H13.5133C12.6781 1.25 12.2598 2.25977 12.8504 2.85039L14.116 4.11602L11.25 6.98242L8.38398 4.11641C7.8957 3.62813 7.1043 3.62813 6.61641 4.11641L3.9332 6.79961C3.68906 7.04375 3.68906 7.43945 3.9332 7.68359L4.8168 8.56719C5.06094 8.81133 5.45664 8.81133 5.70078 8.56719L7.5 6.76758L10.366 9.63359C10.8543 10.1219 11.6457 10.1219 12.1336 9.63359L15.8836 5.88359L17.1492 7.14922C17.7398 7.73984 18.7496 7.32148 18.7496 6.48633V1.875C18.75 1.52969 18.4703 1.25 18.125 1.25Z"
          fill="#F5F5F5"
        />
      </svg>
    </SvgIcon>
  );
};

export const MyJobsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="white"
      width="18px"
      height="18px"
    >
      <path d="M0 0h24v24H0zm10 5h4v2h-4zm0 0h4v2h-4z" fill="none" />
      <path d="M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z" />
    </svg>
  );
};

export const SubIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.32046 19.0001C8.97287 19.0001 10.2522 18.842 11.2785 18.5189C11.2567 18.4022 11.2421 18.2829 11.2421 18.1601C11.2421 17.6115 11.4703 17.1163 11.8351 16.7602C11.4703 16.4041 11.2421 15.9089 11.2421 15.3603C11.2421 14.8117 11.4703 14.3165 11.8351 13.9604C11.4703 13.6043 11.2421 13.1091 11.2421 12.5605C11.2421 12.0119 11.4703 11.5167 11.8351 11.1606C11.4703 10.8045 11.2421 10.3093 11.2421 9.76074C11.2421 9.1127 11.5622 8.54151 12.0488 8.18454C11.7156 7.87962 11.3596 7.60635 10.9861 7.36589C11.1378 7.17486 11.2421 6.94373 11.2421 6.68096C11.2421 6.06237 10.7405 5.56104 10.1217 5.56104H4.51926C3.90037 5.56104 3.39879 6.06237 3.39879 6.68096C3.39879 6.94314 3.50281 7.17354 3.65366 7.36428C1.47865 8.76476 0 11.3008 0 13.9604C0 18.4779 4.19377 19.0001 7.32046 19.0001ZM7.31448 13.5645C6.3876 13.5645 5.63376 12.8111 5.63376 11.8846C5.63376 11.1533 6.10646 10.5364 6.76022 10.3061V9.48075C6.76022 9.17132 7.01087 8.92079 7.32046 8.92079C7.63005 8.92079 7.8807 9.17132 7.8807 9.48075V10.3099C8.52833 10.5434 8.9952 11.1579 8.9952 11.8846C8.9952 12.1942 8.74455 12.4446 8.43496 12.4446C8.12522 12.4446 7.87472 12.1942 7.87472 11.8846C7.87472 11.5756 7.62349 11.3247 7.31448 11.3247C7.00533 11.3247 6.75424 11.5756 6.75424 11.8846C6.75424 12.1936 7.00533 12.4446 7.31448 12.4446C8.24121 12.4446 8.9952 13.1982 8.9952 14.1245C8.9952 14.8513 8.52833 15.4658 7.8807 15.6994V16.2003C7.8807 16.5097 7.63005 16.7602 7.32046 16.7602C7.01087 16.7602 6.76022 16.5097 6.76022 16.2003V15.703C6.10646 15.4729 5.63376 14.8558 5.63376 14.1245C5.63376 13.815 5.88426 13.5645 6.194 13.5645C6.50359 13.5645 6.75424 13.815 6.75424 14.1245C6.75424 14.4335 7.00533 14.6844 7.31448 14.6844C7.62349 14.6844 7.87472 14.4335 7.87472 14.1245C7.87472 13.8155 7.62349 13.5645 7.31448 13.5645Z"
          fill="#F5F5F5"
        />
        <path
          d="M18.194 17.1465H13.3192C12.8738 17.1465 12.5127 17.5615 12.5127 18.0733C12.5127 18.5852 12.8738 19.0001 13.3192 19.0001H18.194C18.6394 19.0001 19.0005 18.5852 19.0005 18.0733C19.0005 17.5615 18.6394 17.1465 18.194 17.1465Z"
          fill="#F5F5F5"
        />
        <path
          d="M18.194 14.3667H13.3192C12.8738 14.3667 12.5127 14.7817 12.5127 15.2935C12.5127 15.8054 12.8738 16.2204 13.3192 16.2204H18.194C18.6394 16.2204 19.0005 15.8054 19.0005 15.2935C19.0005 14.7817 18.6394 14.3667 18.194 14.3667Z"
          fill="#F5F5F5"
        />
        <path
          d="M18.194 11.5854H13.3192C12.8738 11.5854 12.5127 12.0004 12.5127 12.5123C12.5127 13.0241 12.8738 13.4391 13.3192 13.4391H18.194C18.6394 13.4391 19.0005 13.0241 19.0005 12.5123C19.0005 12.0004 18.6394 11.5854 18.194 11.5854Z"
          fill="#F5F5F5"
        />
        <path
          d="M18.194 8.8042H13.3192C12.8738 8.8042 12.5127 9.21918 12.5127 9.73103C12.5127 10.2429 12.8738 10.6579 13.3192 10.6579H18.194C18.6394 10.6579 19.0005 10.2429 19.0005 9.73103C19.0005 9.21918 18.6394 8.8042 18.194 8.8042Z"
          fill="#F5F5F5"
        />
        <path
          d="M8.76674 1.13955C8.53359 0.477778 7.9149 0 7.18219 0C6.44861 0 5.82273 0.476294 5.59017 1.13955H3.80589C3.62506 1.13955 3.45522 1.22739 3.34927 1.37606C3.24376 1.52459 3.2146 1.71599 3.27233 1.8896L4.15085 4.63415H10.2137L11.0921 1.8896C11.1498 1.71599 11.1206 1.52459 11.0151 1.37606C10.9092 1.22739 10.7393 1.13955 10.5585 1.13955H8.76674Z"
          fill="#F5F5F5"
        />
      </svg>
    </SvgIcon>
  );
};

export const WBIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3703 12.5303L15.6875 15.1184H18.5934L19.2761 12.5303H16.3703Z"
          fill="white"
        />
        <path
          d="M14.2046 0H18.4651L14.4769 15.1178H10.125L14.2046 0Z"
          fill="white"
        />
        <path
          d="M13.3055 1.46832L12.9078 0H8.64724L6.45388 8.12839L4.26053 0H0L3.98822 15.1178H4.56801H8.34012H8.91955L11.7989 4.20358L12.1833 5.62707L13.3055 1.46832Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export default GoogleIcon;
